import {createContext} from "react";

export const WithSidebarContext = createContext<{
	isSidebarWrapped: null | boolean;
}>({
	isSidebarWrapped: null,
});
